<template>
  <Form
    ref="loginForm"
    :model="form"
    :rules="rules"
    @keydown.enter.native="handleSubmit"
  >
    <FormItem prop="userName">
      <Input v-model="form.userName" placeholder="please enter user name">
        <span slot="prepend">
          <Icon :size="16" type="ios-person"></Icon>
        </span>
      </Input>
    </FormItem>
    <FormItem prop="password" >
      <Input
        :type="flag?'password':'text'"
        v-model="form.password"
        @on.native.enter="handleSubmit"
        placeholder="please enter the password"
      >
        <span slot="prepend">
          <Icon :size="14" type="md-eye" @click="handlePassword"></Icon>
        </span>
      </Input>
    </FormItem>
    <FormItem>
      <Button @click="handleSubmit" type="primary" long>Login</Button>
    </FormItem>
  </Form>
</template>
<script>
export default {
  name: "LoginForm",
  props: {
    userNameRules: {
      type: Array,
      default: () => {
        return [
          {
            required: true,
            message: "Account cannot be empty",
            trigger: "blur"
          }
        ];
      }
    },
    passwordRules: {
      type: Array,
      default: () => {
        return [
          {
            required: true,
            message: "Password cannot be empty",
            trigger: "blur"
          }
        ];
      }
    }
  },
  data() {
    return {
      form: {
        userName: "",
        password: ""
      },
      flag: true
    };
  },
  computed: {
    rules() {
      return {
        userName: this.userNameRules,
        password: this.passwordRules
      };
    }
  },
  methods: {
    handlePassword() {
      this.flag = !this.flag;
    },
    handleSubmit() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.$emit("on-success-valid", {
            userName: this.form.userName,
            password: this.form.password
          });
        }
      });
    }
  }
};
</script>
